import {useState} from 'react';

import {type Line} from '../../util/plotHelpers/types';
import {type ChartData} from '../vis/chartSeries';
import {prepareChartSeries} from './prepareChartSeries';

const emptyData: ChartData = {
  series: [],
  seriesStylesById: {},
  seriesMetadataById: {},
};

/** One reconciliation owner at the legacy boundary; state retains neutral values only. */
export function usePreparedChartSeries(lines: Line[]): ChartData {
  const [previous, setPrevious] = useState(emptyData);
  const next = prepareChartSeries(lines, previous);
  if (next !== previous) {
    setPrevious(next);
  }
  return next;
}
